import BaseInteraction from './BaseInteraction';
import ContentItem from '../api/content/ContentItem';
import bindHLSjsToWebRTC from '../webrtc/bindHLSjsToWebRTC';
import detemplate from '../util/detemplate';
import logger from '../log';
import { HLS, BindOptions } from './interfaces';
import { MessageTemplates, PlayerNames } from '@kollective-frontend/ksdk-api';
import { SourceType } from '../common/constants';
import { checkType, Types } from '../util/checkTypes';
import attachHlsEvents from './utils/attachHlsEvents';

const { HLS_PLAYER } = PlayerNames;
const { IMPROPER_SETUP } = MessageTemplates;
const HLS_IMPROPER_SETUP = detemplate(IMPROPER_SETUP, { name: HLS_PLAYER });

const log = logger.getLogger(__filename);

export default class HLSjsInteraction extends BaseInteraction<HTMLVideoElement> {
  hls: HLS;
  constructor(videoEl: HTMLVideoElement, hls: HLS) {
    super(videoEl); // Player is an extended video element
    // We don't throw here as that would cascade out and crash the plugin.
    checkType(hls, Types.HLS).emitErrorIfNotCorrectType();
    this.hls = hls;
  }

  bindInterceptor(
    shouldIntercept: () => boolean,
    getOptions: () => BindOptions
  ): void {
    super.bindInterceptor(shouldIntercept, getOptions);
    // XXX: The following should eventually be moved into the constructor,
    // after confirming that there are no complication based on change of timing.
    bindHLSjsToWebRTC(this.hls, this.binder);
  }

  loader(items: ContentItem[]): ContentItem[] {
    const [firstSrc] = items;
    const { url } = firstSrc;
    this.setSource(url);
    return [firstSrc];
  }

  setSource(url: string): void {
    const result = checkType(this.hls, Types.HLS);
    if (result.isType) {
      this.hls.loadSource(url);
      // the player in this case is the element
      this.hls.attachMedia(this.player);
    } else {
      result.log(log, log.ERROR, HLS_IMPROPER_SETUP);
    }
  }

  clearSource(): void {
    if (typeof this.hls.detachMedia === 'function') {
      this.hls.detachMedia();
    } else {
      log.warn(HLS_IMPROPER_SETUP);
    }
  }

  videoElement(): HTMLVideoElement {
    return this.player;
  }

  getAllowedSourceTypes(): SourceType[] {
    return [SourceType.HLS];
  }

  addEventListeners(): void {
    super.addEventListeners();
    this.cleanupMethods.push(attachHlsEvents(this.hls));
  }
}
